import type { CSSProperties } from 'react';
import type { StreamType } from '../nodes/NodeTypes';

export function streamEdgeStyle(streamType: StreamType): CSSProperties {
  return {
    stroke: streamType === 'video' ? 'var(--color-video)' : 'var(--color-audio)',
    strokeWidth: 2.5,
  };
}
